// Source of truth for supported upload extensions in the UI.
// Keep this aligned with `server/src/routes/images.js` (SUPPORTED_EXTS).

export const STANDARD_EXTENSIONS = [
  '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'
];

export const RAW_EXTENSIONS = [
  '.cr2', '.cr3', '.nef', '.arw', '.raf', '.orf',
  '.rw2', '.srw', '.x3f', '.raw', '.pef', '.dng'
];

// HEIF container formats + other non-JPEG "pro" still formats we support.
export const HEIF_AND_PRO_STILL_EXTENSIONS = [
  '.heic', '.heif', '.heics', '.heifs', '.avif', '.tiff', '.tif'
];

export const SUPPORTED_EXTENSION_GROUPS = [
  { key: 'standard', label: 'Standard images', exts: STANDARD_EXTENSIONS },
  { key: 'raw', label: 'RAW / pro', exts: RAW_EXTENSIONS },
  { key: 'heif', label: 'HEIF / AVIF / TIFF', exts: HEIF_AND_PRO_STILL_EXTENSIONS }
];

export const SUPPORTED_EXTENSIONS = [
  ...STANDARD_EXTENSIONS,
  ...RAW_EXTENSIONS,
  ...HEIF_AND_PRO_STILL_EXTENSIONS
];

// Used for heuristics like placeholder detection (RAW exports, HEIC containers, etc.)
export const RAW_OR_PRO_EXTENSIONS = new Set([
  ...RAW_EXTENSIONS,
  ...HEIF_AND_PRO_STILL_EXTENSIONS
]);

// Accept string for <input type="file" ...>.
// `image/*` is convenient for common formats, but explicit extensions help
// when browsers report uncommon types (RAW/HEIF) with empty/odd MIME types.
export const UPLOAD_FILE_ACCEPT = ['image/*', ...SUPPORTED_EXTENSIONS].join(',');

export const SUPPORTED_EXTENSIONS_TEXT = SUPPORTED_EXTENSIONS.join(', ');
